export default "__VITE_ASSET__DQZPNmxv__"